import clsx from "clsx";
import React from "react";
import styles from "./switch.module.css";

interface SwitchProps {
    ariaLabelledby?: string;
    selected: boolean;
    disabled: boolean;
    onChange: (newState: boolean) => void;
    elementId?: string;
}

function ToggleSwitch({
    ariaLabelledby = "",
    selected = false,
    disabled = false,
    onChange = (): void => {},
    elementId = "",
}: SwitchProps): JSX.Element {
    return (
        <div
            id={elementId}
            role="switch"
            aria-labelledby={ariaLabelledby}
            aria-checked={selected}
            data-checked={selected}
            className={clsx(
                styles.toggle,
                { [styles.selected]: selected },
                { [styles.disabled]: disabled }
            )}
            onClick={(): void => {
                onChange(!selected);
            }}
            tabIndex={disabled ? -1 : 0}
        >
            <div className={styles.toggleButton} />
        </div>
    );
}

export default ToggleSwitch;
